export default __webpack_public_path__ + "static/media/IconF5.bd9c52ab.svg";